export default __webpack_public_path__ + "static/media/srcn188_front_keyview_2500x1875.c657804b.jpg";